export default "__VITE_ASSET__CIXkPqvt__"